type ChangeValueSign = {
    isDecrease: boolean;
    unsigned: boolean;
};
export function getChangeValueSign(value: number): Partial<ChangeValueSign> {
    if (value === 0) {
        return {
            unsigned: true,
        };
    }
    return {
        isDecrease: value > 0 ? false : true,
    };
}
